import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.key,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getBatchMessageVariables({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.sendbird.templates.variables,
      params: {
        page: curr_page
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getBatchMessageVariablesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBatchMessageVariablesFailed,
      endpoint: api.sendbird.templates.variables.url
    });
  }
}

export const getBatchMessageVariablesSaga = takeEvery(types.GET_BATCH_MESSAGE_VARIABLES_REQUEST, getBatchMessageVariables);